import imageCompression from 'browser-image-compression'

const defaultOptions = {
  maxWidthOrHeight: 1920,
  useWebWorker: true,
}

export const handleImageUpload = async (event, options = defaultOptions) => {
  const imageFile = event.target.files[0]
  // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
  // alert(`originalFile size ${imageFile.size / 1024 / 1024} MB`)
  try {
    const compressedFile = await imageCompression(imageFile, options)
    // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
    // eslint-disable-next-line max-len
    // alert(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
    return compressedFile
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    // TO DO handle error
  }
  return imageFile
}
